<template>
  <div class="row">
    <div class="col-md-3">
      <Sidenav />
    </div>
    <div class="col-md-9">
      <h2 v-if="!isMobile" class="header-title">Past Orders</h2>
      <b-overlay :show="ordersLoading" rounded="sm">
        <div role="tablist" class="mt-3" style="min-height: 300px">
          <template v-if="orders.length">
            <b-card no-body class="mb-3 order" v-for="(order, index) in orders" :key="index">
              <b-card-header header-tag="header" class="p-3" role="tab">
                <div class="float-left transaction-reference">
                  <h2 :style="{ fontSize: isMobile ? '14px' : '16px'}">Transaction ID {{ order.transaction_no }}</h2>
                  <span class="text-muted" :style="{ fontSize: isMobile ? '14px' : '16px'}">
                    Purchased Date
                    {{ order.created_at | moment("ddd, D MMM YYYY, HH:mm") }}
                  </span>
                </div>
                <img src="@/assets/images/arrow-ios-up.svg" width="35px" alt class="when-open float-right"
                  v-b-toggle="'accordion-' + index" />
                <img src="@/assets/images/arrow-down.svg" width="35px" alt class="when-closed float-right"
                  v-b-toggle="'accordion-' + index" />
              </b-card-header>
              <b-collapse :id="'accordion-' + index" :visible="index == 0" :accordion="'order-accordion-' + index"
                role="tabpanel">
                <b-card-body>
                  <div class="individual-order p-3 mb-3" v-for="(order, index) in order.orders" :key="'order' + index">
                    <b-row>
                      <b-col>
                        <h3 :style="{ fontSize: isMobile ? '14px' : '16px'}">{{ order.brand_name }} ({{ order.branch }})</h3>
                        <span :style="{ fontSize: isMobile ? '14px' : '16px'}">Order ID <br v-if="isMobile" /> {{ order.order_no }}</span>
                      </b-col>
                      <b-col class="text-right">
                        <span class="status text-capitalize fw-bold" v-bind:class="order.status" :style="{ fontSize: isMobile ? '14px' : '16px'}">
                          <template v-if="order.status == 'in_process'">
                            Processing
                          </template>
                          <template v-else>{{ order.status }}</template>
                        </span>
                      </b-col>
                    </b-row>
                  </div>
                  <b-button variant="primary" class="float-right my-3 px-3"
                    :to="'/' + subdomain + '/orders/' + order.uuid"
                    v-if="webDesign !== null && webDesign.design !== null" :style="{
        backgroundColor:
          webDesign.design.main_color + '!important',
        border: 'none !important',
        color: webDesign.design.button_text_color + '!important',
      }">
                    View Order Details
                  </b-button>
                  <b-button variant="primary" class="float-right my-3 px-3"
                    :to="'/' + subdomain + '/orders/' + order.uuid" v-else>
                    View Order Details
                  </b-button>
                </b-card-body>
              </b-collapse>
            </b-card>
          </template>
          <div v-if="!ordersLoading && !orders.length"
            class="d-flex flex-column justify-content-center align-items-center" style="min-height: 300px">
            <div class="text-center">
              <img src="@/assets/images/shopping-bag.png" alt="" />
              <div class="h5 text-secondary">No Past Orders</div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
    <SpecialDiscountRejectedModal :idType="specialDiscountTypeID" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Sidenav from "@/components/layout/Sidenav.vue";
import SpecialDiscountRejectedModal from "@/components/special-discount/SpecialDiscountRejectedModal.vue";

export default {
  data() {
    return {
      specialDiscountLabel: {
        senior: "Senior Citizen",
        pwd: "PWD"
      },
      previousRoute: null,
    };
  },
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      vm.previousRoute = from;
    });
  },
  async created() {
    await this.getOrders();

    if (this.isRejectedSpecialDiscount && this.previousRoute.name === "Checkout") {
      this.$bvModal.show("special-discount-rejected-modal");
      this.$store.commit("estore/setSpecialDiscountValidationStatus", null);
    }
  },
  components: { Sidenav, SpecialDiscountRejectedModal },
  computed: {
    ...mapState("auth", {
      token: (state) => state.token,
      authErrors: (state) => state.errors,
      authIsLoading: (state) => state.loading,
    }),
    ...mapState("merchant", {
      subdomain: (state) => state.subdomain,
      customerPortalToken: (state) => state.customerPortalToken,
      merchantIsLoading: (state) => state.loading,
      merchantErrors: (state) => state.errors,
    }),
    ...mapState("branch", {
      branches: (state) => state.branches,
      branchesNearby: (state) => state.branchesNearby,
      branchesErrors: (state) => state.errors,
      branchesIsLoading: (state) => state.loading,
    }),
    ...mapState("estore", {
      ordersLoading: (state) => state.ordersLoading,
      estoreErrors: (state) => state.errors,
      webDesign: (state) => state.webDesign,
      specialDiscountValidationStatus: state => state.specialDiscountValidationStatus,
    }),
    ...mapGetters({
      orders: "estore/orders",
      isRejectedSpecialDiscount: "estore/isRejectedSpecialDiscount",
      isMobile: "isMobile/isMobile"
    }),
    specialDiscountTypeID() {
      if (this.specialDiscountValidationStatus)
        return this.specialDiscountLabel[this.specialDiscountValidationStatus.special_discount_types];
      
      return "";
    },
  },
  methods: {
    async getOrders() {
      if (this.customerPortalToken) {
        let request = {
          header: {
            Authorization: this.token,
            "X-Merchant-Token": this.customerPortalToken,
          },
          payload: {
            screen: "past",
            order_no: "",
            order_status: "",
          },
        };
        await this.$store.dispatch("estore/getOrders", request);
      }
    },
  },
};
</script>
